<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fiQ6GD/images/MyCoverImage.jpg?1692269907108" alt="This image is the cover for the book Grave of Truth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grave of Truth
      </h1>
      <p class="bookDescription body article font2">
        <p>Max has been having the same dream ever since the end of the war. The horrifying final moments in the Führer’s Bunker, the brutal beating, the dying man—and his last desperate words.<br/>  <br/> Years later Max hears the same words on the lips of another dying man, and finds himself caught in a chilling search for Hitler’s last legacy—the Führer’s final evil bequest. The dream is no longer a dream but a nightmare, and Max must try to live through it. . . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evelyn Anthony
      </h2>
      
      <p class="authorDescription body article">Evelyn Anthony is the pen name of Evelyn Ward-Thomas (1926&ndash;2108), a female British author who began writing in 1949. She gained considerable success with her historical novels&mdash;two of which were selected for the American Literary Guild&mdash;before winning huge acclaim for her espionage thrillers. Her book, <I>The Occupying Power</I>, won the Yorkshire Post Fiction Prize, and her 1971 novel, <I>The Tamarind Seed</I>, was made into a film starring Julie Andrews and Omar Sharif. Anthony&rsquo;s books have been translated into nineteen languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5736bd04